import script from "./ProjectClientRoleDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectClientRoleDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectClientRoleDropdown.vue?vue&type=style&index=0&id=6d631622&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d631622"]])

export default __exports__